import { useEffect, useState } from "react"

import { AudioVideoFacade } from "amazon-chime-sdk-js"

const useVolumeIndicator = (
  attendeeId: string,
  initialAudioMuted: boolean,
  audioVideo: AudioVideoFacade
) => {
  const [muted, setMuted] = useState(initialAudioMuted)

  useEffect(() => {
    if (!attendeeId || !audioVideo) return

    const volumeIndicatorHandler = (
      _attendeeId: string,
      _volume: number,
      muted: boolean,
      _signal: number
    ) => {
      if (muted !== null) setMuted(muted)
    }

    audioVideo.realtimeSubscribeToVolumeIndicator(
      attendeeId,
      volumeIndicatorHandler
    )

    return () => {
      audioVideo.realtimeUnsubscribeFromVolumeIndicator(
        attendeeId,
        volumeIndicatorHandler
      )
    }
  }, [audioVideo, attendeeId])

  return { muted }
}

export default useVolumeIndicator
